import { render, staticRenderFns } from "./AppDaemonBadge.vue?vue&type=template&id=0698b3b8&scoped=true"
import script from "./AppDaemonBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDaemonBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppDaemonBadge.vue?vue&type=style&index=0&id=0698b3b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0698b3b8",
  null
  
)

export default component.exports